import React from "react";

/**
 * Reusable alert modal with the same style as UploadImageModal
 *
 * @param {string} message - The message to display
 * @param {function} onClose - Called when user clicks OK or closes modal
 * @param {string} buttonText - Text for the button (default: "OK")
 * @param {string} type - "error", "warning", or "info" (affects button color)
 */
export default function AlertModal({
  message,
  onClose,
  buttonText = "OK",
  type = "info"
}) {
  const buttonColors = {
    error: { bg: "#ef4444", color: "white" },
    warning: { bg: "#f59e0b", color: "black" },
    info: { bg: "#26EF96", color: "black" },
  };

  const colors = buttonColors[type] || buttonColors.info;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 10000000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
      onClick={onClose}
    >
      <div
        style={{
          width: "80vw",
          maxWidth: "500px",
          background: "white",
          border: "3px solid #000000",
          padding: "20px 30px",
          boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
          textAlign: "center",
          fontFamily: "DM Mono, monospace",
          fontSize: "24px",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <p style={{ margin: "0 0 20px 0", color: "black" }}>{message}</p>
        <div
          style={{
            marginTop: "15px",
            fontSize: "18px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <button
            onClick={onClose}
            style={{
              padding: "10px 30px",
              backgroundColor: colors.bg,
              color: colors.color,
              border: "none",
              cursor: "pointer",
              minWidth: "120px",
              fontFamily: "DM Mono, monospace",
              fontSize: "16px",
            }}
          >
            {buttonText}
          </button>
        </div>
      </div>
    </div>
  );
}
